import { type EmojiMatcher } from '@tari-labs/emojis-wasm-admin';

import { type Pattern } from '@app/client';
import { type EmojiAdminWasm } from '@app/store/types/emoji';

interface WasmPatternCheckResponse {
    matcher?: EmojiMatcher;
    response: string | boolean;
}

export function wasmPatternCheck(wasm: EmojiAdminWasm, pattern: Pattern): WasmPatternCheckResponse {
    const wasmPattern = {
        matcher: undefined,
        response: '',
    } as WasmPatternCheckResponse;

    if (wasm && pattern) {
        try {
            wasmPattern.matcher = new wasm.EmojiMatcher(pattern);
            wasmPattern.response = false;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e: any) {
            wasmPattern.response = e.toString();
        }
    }

    return wasmPattern;
}
